import {simpleClient} from '../context/auth-context.js';
import {useQuery} from '@tanstack/react-query';

// function useDefaultDashboard() {
//   const r = useQuery(['useDefaultDashboard'], () => {
//     return simpleClient(`dashboard`).then((d)=>{
//       console.log("dd : ", d);
//       return d.res;
//     });
//   });
//
//   return r;
//
// }

function useDefaultDashboard() {
  const r = useQuery({
    queryKey: ['useTagDashboard'],
    queryFn: async () => {
      return simpleClient(`dashboard`).then(d => d.res);
    },
  });

  return r;
}



// function useDefaultDashboard() {
//   const r = useQuery({
//     queryKey: ['useDefaultDashboard'],
//     queryFn: async () => {
//       return simpleClient(`dashboard`).then(d => d.res);
//     }
//   });
//   return r;
// }

export {
  useDefaultDashboard
}
